import React, { useState, useEffect } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import pending from "../../../assets/images/pending 2.png";
import PromoFile from "./PromoFile";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const PendingPromoVideo = () => {
  const [buffer, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [count, setPending] = useState("");

  const PendingVideos = () => {
    axios.get(`/api/star/promoVideo/pending`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    PendingVideos();
  }, []);

  useEffect(() => {
    axios.get(`/api/star/promoVideo/count`).then((res) => {
      if (res.status === 200) {
        setPending(res.data.pendingTotal);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title={"Pending Promo Video"}
        image={pending}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <PromoFile
          data={event}
          // text={"pending"}
          urlLink={`/superstar/pending/videoDetails`}
        />
      )}
    </>
  );
};

export default PendingPromoVideo;
